/**
 * Sticky ATC - HICC: price/labels follow purchase mode (same rules as cart line items).
 */
(function () {
  function formatMoney(cents, format) {
    if (cents == null || isNaN(cents)) return '';
    const amount = (Number(cents) / 100).toFixed(2);
    if (!format) return '$' + amount;
    if (format.includes('amount')) {
      return format.replace(/\{\{\s*amount\s*\}\}/, amount).replace(/&gt;/g, '>').replace(/&lt;/g, '<');
    }
    return '$' + amount;
  }

  function parseCents(value) {
    if (value == null) return null;
    if (typeof value === 'number') return value;
    return null;
  }

  function getWidget(sectionId) {
    const subRoot = document.getElementById('pdp-subscription-hicc-' + sectionId);
    return subRoot && subRoot.__pdpSubscriptionHicc ? subRoot.__pdpSubscriptionHicc : null;
  }

  /** Cart line-item rules: display = actual pay price; compare strikethrough only on subscribe. */
  function resolveStickyPrices(widget) {
    if (!widget) return null;
    const variant = widget.getVariant(widget.variantId);
    if (!variant) return null;

    const mode = widget.mode === 'subscribe' ? 'subscribe' : 'onetime';
    const supportsSub = widget.variantSupportsSubscription(variant);

    if (mode === 'subscribe' && supportsSub) {
      const planId = widget.resolveSubscribePlanId(variant);
      let display = null;
      let compare = null;
      if (planId) {
        const planPrices = widget.getPricesForPlan(variant, planId);
        display = planPrices.first;
        compare = planPrices.compare;
      }
      if (display == null) display = widget.readSubscribeTodayCentsFromUi();
      const showCompare =
        compare != null && display != null && compare > display;
      return {
        mode: 'subscribe',
        display,
        compare: showCompare ? compare : null,
      };
    }

    const display = parseCents(variant.price);
    return {
      mode: 'onetime',
      display,
      compare: null,
    };
  }

  function renderStickyPrice(root, sectionId, data) {
    const el = root.querySelector('.price-sticky-' + sectionId);
    if (!el || data == null || data.display == null) return false;

    const widget = getWidget(sectionId);
    const fmt = widget && widget.moneyFormat;
    const formatted = formatMoney(data.display, fmt);

    if (data.mode === 'subscribe') {
      let html = '<span class="sticky-atc-hicc__sub-price">' + formatted + '</span>';
      if (data.compare != null) {
        html +=
          '<s class="sticky-atc-hicc__compare">' +
          formatMoney(data.compare, fmt) +
          '</s>';
      }
      el.innerHTML = html;
      return true;
    }

    el.innerHTML =
      '<span class="sticky-atc-hicc__price-plain sticky-atc-hicc__price-plain--onetime">' +
      formatted +
      '</span>';
    return true;
  }

  function syncPriceFallback(sectionId, root) {
    const mainPrice = document.getElementById('price-' + sectionId);
    const stickyPrice = root.querySelector('.price-sticky-' + sectionId);
    if (!mainPrice || !stickyPrice) return;
    const source =
      mainPrice.querySelector('.main-product-price') ||
      mainPrice.querySelector('.price') ||
      mainPrice;
    if (source) stickyPrice.innerHTML = source.innerHTML;
  }

  function ctaWithPrice(base, mainAtc) {
    const span = mainAtc?.querySelector('.x-atc-text .button-text, .button-text');
    if (span && span.textContent.includes(' - ')) {
      const pricePart = span.textContent.split(' - ').slice(1).join(' - ').trim();
      if (pricePart) return base + ' - ' + pricePart;
    }
    return base;
  }

  function syncSticky(root) {
    const sectionId = root.dataset.sectionId;
    const labelEl = root.querySelector('[data-hicc-sticky-label]');
    const ctaTextEl = root.querySelector('[data-hicc-sticky-cta-text]');
    const mainAtc = document.getElementById('x-atc-button-' + sectionId);
    if (!sectionId || !labelEl || !ctaTextEl) return;

    const widget = getWidget(sectionId);
    const mode = widget ? (widget.mode === 'subscribe' ? 'subscribe' : 'onetime') : 'onetime';

    const subLabel = root.dataset.subLabel || 'Subscribe & Save';
    const onetimeLabel = root.dataset.onetimeLabel || 'One-time purchase';
    const ctaSubscribe = root.dataset.ctaSubscribe || 'SUBSCRIBE NOW';
    const ctaOnetime = root.dataset.ctaOnetime || 'ADD TO CART';

    labelEl.textContent = mode === 'subscribe' ? subLabel : onetimeLabel;
    ctaTextEl.textContent =
      mode === 'subscribe' ? ctaWithPrice(ctaSubscribe, mainAtc) : ctaWithPrice(ctaOnetime, mainAtc);

    const prices = widget ? resolveStickyPrices(widget) : null;
    if (!prices || !renderStickyPrice(root, sectionId, prices)) {
      syncPriceFallback(sectionId, root);
    }
  }

  function bindRoot(root) {
    if (root.__pdpStickyAtcHiccBound) return;
    root.__pdpStickyAtcHiccBound = true;
    const sectionId = root.dataset.sectionId;

    syncSticky(root);

    document.addEventListener('pdp-hicc:purchase-mode', function (e) {
      if (!e.detail || String(e.detail.sectionId) !== String(sectionId)) return;
      syncSticky(root);
    });

    document.addEventListener('eurus:product-page-variant-select:updated:' + sectionId, function () {
      requestAnimationFrame(function () {
        syncSticky(root);
      });
    });

    document.addEventListener('sealsubs:price_update', function () {
      requestAnimationFrame(function () {
        syncSticky(root);
      });
    });

    const freqSelect = document
      .getElementById('pdp-subscription-hicc-' + sectionId)
      ?.querySelector('[data-pdp-frequency-select]');
    if (freqSelect) {
      freqSelect.addEventListener('change', function () {
        syncSticky(root);
      });
    }
  }

  function init() {
    const roots = document.querySelectorAll('.sticky-atc-hicc[data-section-id]');
    roots.forEach(bindRoot);
    if (!roots.length) {
      let tries = 0;
      const timer = setInterval(function () {
        tries += 1;
        const next = document.querySelectorAll('.sticky-atc-hicc[data-section-id]');
        next.forEach(bindRoot);
        if (next.length || tries > 50) clearInterval(timer);
      }, 100);
    }
  }

  document.addEventListener('alpine:initialized', init);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
